// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletPage_wallet-page__content__7IlPf {
  max-width: 1200px;
  margin: 1px auto;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/WalletPage/WalletPage.module.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;AAAJ","sourcesContent":[".wallet-page {\n  &__content {\n    max-width: 1200px;\n    margin: 1px auto;\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wallet-page__content": `WalletPage_wallet-page__content__7IlPf`
};
export default ___CSS_LOADER_EXPORT___;
